import axios from "axios";
import Cookies from "js-cookie";

const getAccessToken = () => sessionStorage.getItem("accessToken") || Cookies.get("accessToken");

const buildAuthHeaders = () => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    return {};
  }

  return {
    Authorization: `Bearer ${accessToken}`,
  };
};

const normalizeStatusResponse = (data = {}) => ({
  isEnabled: data.isEnabled ?? data.IsEnabled ?? false,
  isConfigured: data.isConfigured ?? data.IsConfigured ?? false,
});

const normalizeSetupResponse = (data = {}) => ({
  qrCodeUrl: data.qrCodeUrl ?? data.QrCodeUrl ?? "",
  manualEntryKey: data.manualEntryKey ?? data.ManualEntryKey ?? "",
});

const request = async (config) => {
  try {
    const response = await axios({
      ...config,
      headers: {
        ...(config.headers || {}),
        ...buildAuthHeaders(),
      },
    });

    return {
      ok: true,
      status: response.status,
      data: response.data,
      message: response.data?.message ?? response.data?.Message ?? "",
    };
  } catch (error) {
    const status = error?.response?.status;
    const data = error?.response?.data;
    const message = data?.message ?? data?.Message ?? error?.message ?? "Something went wrong";

    return {
      ok: false,
      status,
      data,
      message,
    };
  }
};

export const getStatus = async () => {
  const result = await request({
    method: "GET",
    url: "/api/mfa/status",
  });

  if (!result.ok) {
    return result;
  }

  return {
    ...result,
    data: normalizeStatusResponse(result.data),
  };
};

export const getSetup = async () => {
  const result = await request({
    method: "GET",
    url: "/api/mfa/setup",
    params: { t: Date.now() },
  });

  if (!result.ok) {
    return result;
  }

  return {
    ...result,
    data: normalizeSetupResponse(result.data),
  };
};

export const verify = async (code) =>
  request({
    method: "POST",
    url: "/api/mfa/verify",
    data: { code },
  });

export const enable = async (code) =>
  request({
    method: "POST",
    url: "/api/mfa/enable",
    data: { code },
  });

export const disable = async (code) =>
  request({
    method: "POST",
    url: "/api/mfa/disable",
    data: { code },
  });
